(ns ui.hover-card
  (:require
   ["@radix-ui/react-hover-card" :as RadixHoverCard]
   [ui.utils :refer [clsx separate-props]]))

(defn hover-card-root [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixHoverCard/Root props]
          children)))

(defn hover-card-trigger [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixHoverCard/Trigger props]
          children)))

(defn hover-card-content [& args]
  (let [[props children] (separate-props args)]
    [:> RadixHoverCard/Portal
     (into [:> RadixHoverCard/Content
            (cond-> props
              (not (:sideOffset props))
              (assoc :sideOffset 5)

              true
              (update :class #(clsx "z-2000 shadow-lg rounded-md p-4 bg-white dark:bg-kleene-dark-01 ring-1 ring-black/5 radix-state-open:animate-fade-in" %)))
            [:> RadixHoverCard/Arrow {:fill "white" :class "shadow-xs dark:fill-kleene-dark-01"}]]
           children)]))

